import {
  ga,
  outbrain,
  revcontent,
  strossle,
  zemanta,
  avocet,
} from 'js/analytics/adapters'
import { getItem } from 'js/storeManager'

export const trackAppStoreButtonClick = ({ type }) => {
  ga.track('App store buttons Click', {
    type,
  })

  strossle.track('conversion')

  const installPostbackUrl = getItem('install_callback')
  installPostbackUrl && fetch(installPostbackUrl)
  outbrain.install()
  revcontent.track('Install')
  zemanta.track('Install')
  avocet.track('Install', { type })

  // MGID
  const mgidPostbackUrl = getItem('mgid_postback')
  mgidPostbackUrl && fetch(mgidPostbackUrl)
}
